import React, { useEffect, useState } from "react";
import jQuery, { post } from "jquery";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Spinner,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { MDBDataTableV5 } from "mdbreact";
import { useSelector } from "react-redux";
// Require Editor JS files.

// Require Font Awesome.
import "font-awesome/css/font-awesome.css";
import { BASE_URL } from "../utils/constants";
import axios from "axios";
import Swal from "sweetalert2";
// import { maxWidth } from "@mui/system";

function WallofLove() {
  const permissions = useSelector((state) => state.permissions);
  const [proId, setProId] = useState("");
  const [file, setFile] = useState(null);
  const [datatable, setDatatable] = useState({
    columns: [
      {
        label: "#",
        field: "serial",
      },
      {
        label: "Title",
        field: "title",
      },
      {
        label: "Date",
        field: "date",
      },

      {
        label: "Status",
        field: "status",
      },
      {
        label: "Actions",
        field: "actions",
      },
    ],
    rows: [
      {
        serial: <Spinner color="info" />,
        titel: <Spinner color="info" />,
        date: <Spinner color="info" />,
        status: <Spinner color="info" />,
        actions: <></>,
      },
    ],
  });
  const [formData, setFormData] = useState({
    id: "0",
    title: "",
    description: "",
    driveId: "",
    video_image: "",
  });
  const [mood, setMood] = useState("new");
  const [model, setModal] = useState(false);

  useEffect(() => {
    (async () => {
      let res = [];
      try {
        res = await axios.post(
          `${BASE_URL}/student/walloflove/getwallofloveposts.php`,
          {
            sId: permissions.id,
          }
        );
        setDatatable((prevState) => {
          const newState = { ...prevState };
          let ser = 1;
          let newRows = res.data.data?.map((wallpost, key) => {
            return {
              ...wallpost,
              serial: ser++,
              title: wallpost.title,
              date: wallpost.date,
              status:
                wallpost.status !== "Pending" ? "Confirmed" : wallpost.status,
              actions: (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <a
                      style={{ backgroundColor: "#0000FF" }}
                      className=" btn btn-primary  m-2 fw-bolder w-25"
                      onClick={() => handleViewModal(wallpost.id, "view")}
                    >
                      View
                    </a>

                    <button
                      className=" btn btn-success m-2 fw-bolder w-25 "
                      onClick={() => handleViewModal(wallpost.id, "edit")}
                      disabled={wallpost.status !== "Pending"}
                    >
                      Edit
                    </button>
                  </div>
                </>
              ),
            };
          });
          return { ...newState, rows: newRows };
        });
      } catch { }
    })();
  }, []);

  const clearFormData = () => {
    setFormData((prevState) => ({
      ...prevState,
      id: "0",
      title: "",
      description: "",
      driveId: "",
    }));
    setFile(null);
    setMood("new");
  };
  const handleSelectFile = (e) => {
    if (e.target.files === null) return;
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    if (e.target.files[0]?.type?.match("image") === null) {
      getThumbnail(selectedFile);
    }
  };

  const handleViewModal = async (id, mood) => {
    Swal.showLoading();
    try {
      const res = await axios.post(
        `${BASE_URL}/student/walloflove/getwalloflovepost.php`,
        {
          id: id,
        }
      );
      setMood(mood);
      let item = res.data.data;

      setFormData((prevState) => ({
        ...prevState,
        id: item.id,
        title: item.title,
        description: item.body,
        driveId: item.drive_id,
        video_image: item.video_image_id,
      }));
      setModal(true);
    } catch (e) {
      let ee = e;

      Swal.fire(ee?.response?.data.msg || "Failed to upload", "", "error");
    } finally {
      Swal.close();
    }
  };
  // get thumbnail
  function getThumbnail(file) {
    var fileReader = new FileReader();
    if (file.type.match("image")) {
      // fileReader.onload = function () {
      //   $("#blah").attr("src", fileReader.result);
      // };
      // fileReader.readAsDataURL(file);
    } else {
      fileReader.onload = function () {
        var blob = new Blob([fileReader.result], {
          type: file.type,
        });
        var url = URL.createObjectURL(blob);
        var video = document.createElement("video");
        var timeupdate = function () {
          if (snapImage()) {
            video.removeEventListener("timeupdate", timeupdate);
            video.pause();
          }
        };
        video.addEventListener("loadeddata", function () {
          if (snapImage()) {
            video.removeEventListener("timeupdate", timeupdate);
          }
        });
        var snapImage = function () {
          var canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, canvas.width, canvas.height);
          var image = canvas.toDataURL();
          var success = image.length > 100000;
          // Thumbnail --- image  base64
          if (success) {
            // $("#video_image").val(image);
            setFormData((prevState) => ({
              ...prevState,
              video_image: image,
            }));
          }
          return success;
        };
        video.addEventListener("timeupdate", timeupdate);
        video.preload = "metadata";
        video.src = url;
        // Load video in Safari / IE11
        video.muted = true;
        video.playsInline = true;
        video.play();
      };
      fileReader.readAsArrayBuffer(file);
    }
  }
  // document.getElementById("photo").addEventListener("change", function (event) {
  //   getThumbnail(event.target.files[0]);
  // });
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    Swal.showLoading();
    let SendData = new FormData();
    SendData.append("id", formData.id);
    SendData.append("file", file);
    SendData.append("description", formData.description);
    SendData.append("title", formData.title);
    SendData.append("video_image", formData.video_image);

    axios
      .post(`${BASE_URL}/student/walloflove/addwalloflovepost.php`, SendData, {
        headers: { "content-type": "multipart/form-data" },
      })
      .then((res) => {
        setDatatable((prevState) => {
          const newState = { ...prevState };
          let ser = 1;
          let newRows = res.data.data?.map((wallpost, key) => {
            return {
              ...wallpost,
              serial: ser++,
              title: wallpost.title,
              date: wallpost.date,
              status: wallpost.status,
              actions: (
                <>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <a
                      style={{ backgroundColor: "#0000FF" }}
                      className=" my-1 btn btn-primary fw-bolder"
                      onClick={() => handleViewModal(wallpost.id, "view")}
                    >
                      View
                    </a>

                    <button
                      className=" my-1 btn btn-success fw-bolder w-25"
                      onClick={() => handleViewModal(wallpost.id, "edit")}
                      disabled={wallpost.status !== "Pending"}
                    >
                      Edit
                    </button>
                  </div>
                </>
              ),
            };
          });
          return { ...newState, rows: newRows };
        });
      })
      .catch((e) => {
        let ee = e;

        Swal.fire(ee?.response?.data.msg || "Failed to upload", "", "error");
      })
      .finally(() => {
        clearFormData();
        setModal(false);
        Swal.fire("Saved Successfully", "", "success");
      });
  };

  return (
    <>
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card className="w-100">
              <CardHeader className="text-center">
                <h4 className="fw-bolder">
                  WaLL Of Love{" "}
                  <i className={"fas fa-heart"} style={{ color: "red" }}></i>{" "}
                </h4>
                <h6 className="fw-bolder">
                  A pLace where Students, Parents and Teachers share their
                  love for{" "}
                </h6>
                <h6 className="fw-bolder">The school life</h6>
              </CardHeader>
              <div className="text-center">
                <button
                  style={{ backgroundColor: "#0000FF" }}
                  className=" fw-bolder mx-auto w-25 btn btn-primary "
                  onClick={() => {
                    clearFormData();
                    setModal(true);
                  }}
                >
                  Add Wall Post
                </button>
              </div>

              <CardBody className="all-icons">
               
                  <MDBDataTableV5
                    hover
                    responsive
                    bordered
                    borderless={false}
                    striped
                    entriesOptions={[5, 20, 25]}
                    entries={10}
                    pagesAmount={4}
                    data={datatable}
                    fullPagination
                    searchTop
                    searchBottom={false}
                  />
                
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={model}
          className="modal-md"
          style={{ width: "50%", height: "50%", top: "20" }}
        >
          <ModalHeader className="bg-info fw-bolder">
            Wall OF Love Post Details
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={submitHandler}>
              <div>
                <label>Post Title</label>{" "}
                <span style={{ color: "red" }}>*</span>
                <Input
                  style={{ borderColor: "black" }}
                  onChange={handleChange}
                  name="title"
                  type="text"
                  value={formData.title}
                  disabled={mood === "view"}
                ></Input>
              </div>
              <div>
                <label>Description</label>{" "}
                <span style={{ color: "red" }}>*</span>
                <textarea
                  onChange={handleChange}
                  name="description"
                  rows="4"
                  value={formData.description}
                  disabled={mood === "view"}
                  className="col-12"
                ></textarea>
              </div>
              <div>
                <Input className="d-none" id="video_image"></Input>
                <label>Upload Image or Video</label>
                <span style={{ color: "red" }}>*</span>
                {mood === "edit" ? (
                  <p>
                    If you want to change the attached media just upload another
                    file and it will be edited
                  </p>
                ) : null}
                <Input
                  onChange={handleSelectFile}
                  name="file"
                  type="file"
                  disabled={mood === "view"}
                ></Input>
              </div>
              {formData.driveId ? (
                <div>
                  <label>Uploaded Image or Video Thumbnail </label>

                  {formData.video_image ? (
                    <video
                      controls
                      className="Lazy"
                      id={formData.id}
                      preload="none"
                      poster={formData.video_image?.includes("https://")?formData.video_image :`https://drive.google.com/uc?id=${formData.video_image}&export=download`}
                      style={{ width: "100%", maxHeight: "50%" }}
                    >
                      <source
                        src={formData.driveId?.includes("https://")?formData.driveId :`https://drive.google.com/uc?id=${formData.driveId}&export=download"`}
                        type="video/mp4"
                      ></source>
                    </video>
                  ) : (
                    <img
                      className="col-12"
                      src={formData.driveId?.includes("https://")?formData.driveId :`https://drive.google.com/uc?id=${formData.driveId}&export=download`}
                    ></img>
                  )}
                </div>
              ) : null}
              {formData.driveId ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    style={{ width: "50%" }}
                    className="btn btn-primary m-3"
                    type="submit"
                    disabled={
                      mood === "view" ||
                      formData.title === "" ||
                      formData.description === ""
                    }
                  >
                    Submit
                  </button>
                </div>
              ) : (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    style={{ width: "50%" }}
                    className="btn btn-primary m-3"
                    type="submit"
                    disabled={
                      mood === "view" ||
                      file === null ||
                      formData.title === "" ||
                      formData.description === ""
                    }
                  >
                    Submit
                  </button>
                </div>
              )}
            </Form>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={() => setModal(false)}
            >
              Close
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

export default WallofLove;
